// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

  .fc-theme-bootstrap a:not([href]) {
    color: inherit; /* natural color for navlinks */
  }
`, "",{"version":3,"sources":["webpack://./node_modules/@fullcalendar/bootstrap/main.css"],"names":[],"mappings":";;EAEE;IACE,cAAc,EAAE,+BAA+B;EACjD","sourcesContent":["\n\n  .fc-theme-bootstrap a:not([href]) {\n    color: inherit; /* natural color for navlinks */\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
